import * as Common from "../../commons/common"

export class Teacher {
  user_id: number
  login_id: string
  name: string
  at_full_count: number

  constructor(teacher: any){
    this.user_id = teacher.id;
    this.login_id = teacher.login_id;
    this.name = teacher.name;
    this.at_full_count = teacher.at_full_count;
  }
}

export class TeacherListCondition{
  login_id: string = ""
  name: string = ""
  role: string = ""
  page: number = 1
  row_count: number =  Common.TeacherListRowCount
}

export class PasswordForm {
  user_id: number
  login_id: string
  name: string
  password: string = ""
  password_confirmation: string = ""

  constructor(teacher: Teacher){
    this.user_id = teacher.user_id;
    this.login_id = teacher.login_id;
    this.name = teacher.name;
  }
}